const HttpClient = {
  get(url: string, token: any, payload: object = {}, method = "GET") {
    return token().then((token: string) => this.fetchData(url, "Bearer " + token.replace("Bearer ", ""), payload, method))
  },

  fetchData(url: string, token: string, payload: object = {}, method = "GET") {
    return new Promise(function (resolve, reject) {
      const xhr = new XMLHttpRequest()
      xhr.open(method, url, true)
      xhr.setRequestHeader("Content-Type", "application/json")
      xhr.setRequestHeader("Accept", "application/json")
      xhr.setRequestHeader("Authorization", token)

      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300 && xhr.response) {
          const response = JSON.parse(xhr.response)
          resolve(response)
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText
          })
        }
      }

      xhr.onerror = function () {
        reject({
          status: this.status,
          statusText: xhr.statusText
        })
      }
      xhr.send(JSON.stringify(payload))
    })
  }
}

export default HttpClient
